<main>
  <!-- <app-all-afd/> -->
   <!-- <main-layout [metaId]="'id:KAPI#main_afd_list'"></main-layout> -->
    <!-- <router-outlet /> -->
     <app-main></app-main>
</main>